export default "__VITE_ASSET__deqym7TN__"